<script>
import AssetPage from '@/views/AadenPages/memberShipReborn/Asset/AssetPage.vue'

export default {
  name: 'AssetIndex',
  components: {
    AssetPage
  }
}
</script>

<template>
  <div>
    <asset-page />
  </div>
</template>

<style scoped>

</style>
